/** @jsx jsx */
import { jsx, Flex } from 'theme-ui';
import { Image } from '@builder.io/react';
import theme from '../../gatsby-plugin-theme-ui-v1';

const Block = ({
  alignItems,
  backgroundColor,
  backgroundColorOverride,
  backgroundImage,
  backgroundMedia,
  borderRadius,
  boxShadow,
  children,
  justifyContent,
  mediaObjectFit,
  mediaObjectPosition,
  padding,
  textWidth,
}) => (
  <Flex
    sx={{
      alignContent: 'center',
      alignItems: 'stretch',
      bg: backgroundColorOverride || backgroundColor,
      borderRadius,
      boxShadow,
      flex: 1,
      justifyContent: 'center',
      overflow: 'hidden',
      p: padding,
      position: 'relative',
      maxWidth: textWidth ? theme.sizes.container[1] : 'auto',
      margin: textWidth ? '0 auto' : 'inherit',
    }}
  >
    {backgroundMedia === 'image' && backgroundImage && (
      <Image
        image={backgroundImage}
        sx={{
          height: '100%',
          left: 0,
          objectFit: mediaObjectFit,
          objectPosition: mediaObjectPosition,
          position: 'absolute',
          top: 0,
          width: '100%',
        }}
      />
    )}
    <Flex
      sx={{
        alignItems,
        height: '100%',
        flexDirection: 'column',
        justifyContent,
        width: '100%',
        zIndex: 10,
      }}
    >
      {children}
    </Flex>
  </Flex>
);

export default Block;
